module.exports = __webpack_public_path__ + "static/media/r3s2.c8b60339.jpg";